<template>
  <div class="atom-video">
    <video
      v-if="fileExtension && filename"
      ref="videoRef"
      class="atom-video__element"
      allowfullscreen
      :controls="isPlaying"
      preload="metadata"
      @play="isPlaying = true"
      @pause="isPlaying = false"
    >
      <source
        :src="`${filename}#t=0.01`"
        :type="`video/${fileExtension}`"
      >
      <track
        v-if="data.caption?.filename"
        default
        kind="captions"
        srclang="de"
        label="Deutsch"
        :src="data.caption?.filename"
      >
    </video>

    <transition name="fade-in">
      <AppIcon
        v-if="!isPlaying"
        :is-raw="true"
        icon="play"
        class="atom-video__play"
        @click="play()"
        @keypress="play()"
      />
    </transition>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

/*
    Setup
*/
const isPlaying = ref(false);
const storyStore = useStoryStore();
/*
  Get filename
*/
const filename = computed(() => {
    if (props.data?.strapi_data_key) {
        return storyStore.getConnectedStrapiValue(props.data.strapi_data_key)?.url;
    }

    return props?.data?.video?.filename;
});

const fileExtension = computed(() => {
    const splitted = filename?.value?.split('.');
    return splitted ? splitted.pop() : false;
});

/*
    Handle play button
*/
const videoRef = ref(null);
const play = () => {
    videoRef.value.play();
};
</script>

<style lang="scss" scoped>
.atom-video {
    @include top-level-only {
        @include default-content-columns(true);
    }
    @include component-spacing(44px, 80px);
    @include fluid('border-radius', 6px, 12px);

    position: relative;
    overflow: hidden;
    font-size: 0;
    line-height: 0;
}

.atom-video__element {
    width: 100%;
    height: auto;
}

.atom-video__play {
    @include fluid('height', 44px, 80px);
    @include fluid('width', 44px, 80px);

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    cursor: pointer;
    transform: translate3d(0,0,0);
}
</style>
